import EXTENSIONS from "@/constants/extensions";
import { filter } from "lodash";

const ENABLED = "ENABLED";

export default {
    data() {
        return {
            showSendToLab: false
        };
    },
    methods: {
        isShowSendToLab(labData) {
            let self = this;
            let labSource = labData.source;
            if (labSource && labSource.includes("IDEXX_DEVICE"))
                labSource = "IDEXX_DEVICE";

            switch (labSource) {
                case EXTENSIONS.CODE.CODE_ANTECH:
                case EXTENSIONS.CODE.CODE_ANTECH_EAST:
                case EXTENSIONS.CODE.CODE_ANTECH_WEST:
                case EXTENSIONS.CODE.CODE_IDEXX:
                case EXTENSIONS.CODE.CODE_IDEXX_DEVICE:
                case EXTENSIONS.CODE.CODE_MIDWEST:
                case EXTENSIONS.CODE.CODE_NBIOVET:
                case EXTENSIONS.CODE.CODE_ZNLABS:
                case EXTENSIONS.CODE.CODE_VETEK:
                case EXTENSIONS.CODE.CODE_MICROVET:
                case EXTENSIONS.CODE.CODE_BIONOTE:
                case EXTENSIONS.CODE.CODE_HESKA_CLOUD:
                    if (labData.sent_to == 1) {
                        self.showSendToLab = true;
                    } else {
                        if (
                            labSource == EXTENSIONS.CODE.CODE_ANTECH_EAST ||
                            labSource == EXTENSIONS.CODE.CODE_ANTECH_WEST
                        ) {
                            if (
                                self._isExtensionEnabled(
                                    EXTENSIONS.CODE.CODE_ANTECH
                                )
                            ) {
                                self.showSendToLab = true;
                            }
                        } else {
                            if (labSource.includes("IDEXX_DEVICE")) {
                                labSource = EXTENSIONS.CODE.CODE_IDEXX;
                            }

                            if (self._isExtensionEnabled(labSource)) {
                                self.showSendToLab = true;
                            }
                        }
                    }

                    break;

                default:
                    if (
                        labData.is_abaxis_api &&
                        (self._isExtensionEnabled(
                            EXTENSIONS.CODE.CODE_ABAXIS_API
                        ) ||
                            self._isExtensionEnabled(
                                EXTENSIONS.CODE.CODE_ABAXIS_FUSE
                            ))
                    ) {
                        self.showSendToLab = true;
                    }

                    if (labSource == EXTENSIONS.CODE.CODE_ONPREM_ABAXIS) {
                        self.showSendToLab = true;
                    }
                    break;
            }

            return self.showSendToLab;
        },
        sendToLabLabel(labData) {
            let sendToLabLabel = "Send To Lab:";
            let labSource = labData.source.toUpperCase();

            if (labData.is_abaxis_api) {
                sendToLabLabel = "Send To Analyzer:";
            } else if (labData.is_idexx_in_house) {
                sendToLabLabel = "Send To VetLab:";
            } else if (labSource == EXTENSIONS.CODE.CODE_HESKA_CLOUD) {
                sendToLabLabel = "Send To Analyzer:";
            } else if (
                labSource != EXTENSIONS.CODE.CODE_ANTECH &&
                labSource != EXTENSIONS.CODE.CODE_ANTECH_WEST &&
                labSource != EXTENSIONS.CODE.CODE_ANTECH_EAST &&
                labSource != EXTENSIONS.CODE.CODE_IDEXX &&
                labSource != EXTENSIONS.CODE.CODE_MIDWEST &&
                labSource != EXTENSIONS.CODE.CODE_NBIOVET &&
                labSource != EXTENSIONS.CODE.CODE_ZNLABS &&
                labSource != EXTENSIONS.CODE.CODE_VETEK &&
                labSource != EXTENSIONS.CODE.CODE_MICROVET &&
                labSource != EXTENSIONS.CODE.CODE_BIONOTE
            ) {
                sendToLabLabel = "Send To Analyzer:";
            }
            return sendToLabLabel;
        },
        showStatusLabel(record) {
            let str = "";
            if (record.summary.statusName) {
                str = record.summary.statusName;
            }

            if (
                record.received_date &&
                (str.toUpperCase() == "COMPLETED" ||
                    str.toUpperCase() == "COMPLETE" ||
                    str.toUpperCase() == "PARTIAL RESULTS")
            ) {
                str =
                    str +
                    " (" +
                    this._carbonDateTimeDisplay(record.received_date) +
                    ")";
            }

            return str;
        },
        getEnabledHeska() {
            let extensions = filter(this.$root.extensions, function (ext) {
                if (["ONPREM", "HESKA_CLOUD"].includes(ext.extension_code)) {
                    return ext.status == ENABLED;
                }
            });

            let enabledHeska = null;
            if (extensions.length > 0) {
                if (extensions.length == 2) {
                    enabledHeska = EXTENSIONS.CODE.CODE_ONPREM_HESKA.toUpperCase();
                } else {
                    enabledHeska =
                        extensions[0].extension_code == "ONPREM"
                            ? EXTENSIONS.CODE.CODE_ONPREM_HESKA.toUpperCase()
                            : EXTENSIONS.CODE.CODE_HESKA_CLOUD;
                }
            }
            return enabledHeska;
        },
        async getLabIntegrationObject(response, module, param = {}) {
            let printLabParams = {
                idexx_lab_id: response.idexx_lab_id,
                idexx_url: response.idexx_url,
                lab_ids: response.lab_ids,
                source: response.lab_source,
                module: module,
                module_url: response.url,
                ...param
            };

            let labResponse = await this._print_lab_order(printLabParams);

            return {
                ...labResponse,
                module_url: printLabParams.module_url,
                module: printLabParams.module
            };
        }
    }
};
